import { useLayoutEffect, useRef, useState } from "react";

const useClampContent = (maxLines = 6, isPdfView = false) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showMoreButton, setShowMoreButton] = useState(false);
  const [isClamp, setIsClamp] = useState(false);

  useLayoutEffect(() => {
    if (!ref?.current) return;
    const computedStyle = getComputedStyle(ref.current);
    let lineHeight = parseFloat(computedStyle.lineHeight);
    // line height can be a string
    if (isNaN(lineHeight)) {
      lineHeight = parseFloat(computedStyle.fontSize) * 1.2;
    }

    if (ref.current.scrollHeight > lineHeight * maxLines && !isPdfView) {
      setIsClamp(true);
      setShowMoreButton(true);
    }
  }, [isPdfView, maxLines]);

  return { showMoreButton, isClamp, setIsClamp, ref };
};

export default useClampContent;
